import { Component, inject } from '@angular/core';
import { FirestoreService } from '@services/firestore/firestore.service';
import { IConfiguracionesTexto } from '@interfaces/reforma-configuraciones-texto.interface';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-beneficios-cotizados',
    templateUrl: './beneficios-cotizados.component.html',
    styleUrl: './beneficios-cotizados.component.scss',
    standalone: false
})
export class BeneficiosCotizadosComponent {

  private readonly firestoreService = inject(FirestoreService);

  content$: Observable<IConfiguracionesTexto> = this.firestoreService
    .getDoc<IConfiguracionesTexto>('reforma-pensiones', 'configuraciones-texto');

}